import React from "react";
import SourceIQLogo from "../UILibrary/SourceIQLogo";
import { useNavigate } from "react-router-dom";

const SidePanel = ({
  isPanelOpen,
  toggleMenu,
  menuItems,
  selectedItem,
  setSelectedItem,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={`h-screen z-[1000] fixed top-0 left-0  ${
        isPanelOpen ? "w-56" : "w-24"
      }
      transition-all duration-300 whitespace-nowrap bg-white`}
    >
      <div className="flex justify-between items-center p-5">
        <SourceIQLogo fill="#1E1E1E" width={150} height={30} />

        <button className="toggle-button ml-4" onClick={toggleMenu}>
          {isPanelOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4 4C4 3.44772 4.44772 3 5 3C5.55228 3 6 3.44772 6 4V20C6 20.5523 5.55228 21 5 21C4.44772 21 4 20.5523 4 20V4Z"
                fill="#131313"
              />
              <path
                d="M12.9497 6.70711C13.3403 6.31658 13.9734 6.31658 14.364 6.70711C14.7545 7.09763 14.7545 7.7308 14.364 8.12132L10.1213 12.364C9.73079 12.7545 9.09763 12.7545 8.70711 12.364L8.21213 11.869C8.09497 11.7518 8.09497 11.5619 8.21213 11.4447L12.9497 6.70711Z"
                fill="#131313"
              />
              <path
                d="M14.364 15.9498C14.7545 16.3403 14.7545 16.9734 14.364 17.364C13.9734 17.7545 13.3403 17.7545 12.9497 17.364L8.28284 12.6971C8.12663 12.5409 8.12663 12.2876 8.28284 12.1314L8.70711 11.7071C9.09763 11.3166 9.7308 11.3166 10.1213 11.7071L14.364 15.9498Z"
                fill="#131313"
              />
              <path
                d="M19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H9.23607C9.08082 13 8.92771 12.9639 8.78885 12.8944L8.44721 12.7236C8.17313 12.5866 8 12.3064 8 12C8 11.6936 8.17313 11.4134 8.44721 11.2764L8.78885 11.1056C8.92771 11.0361 9.08082 11 9.23607 11H19Z"
                fill="#131313"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M20 20C20 20.5523 19.5523 21 19 21C18.4477 21 18 20.5523 18 20L18 4C18 3.44772 18.4477 3 19 3C19.5523 3 20 3.44772 20 4L20 20Z"
                fill="black"
              />
              <path
                d="M11.0503 17.2929C10.6597 17.6834 10.0266 17.6834 9.63604 17.2929C9.24552 16.9024 9.24552 16.2692 9.63604 15.8787L13.8787 11.636C14.2692 11.2455 14.9024 11.2455 15.2929 11.636L15.7879 12.131C15.905 12.2482 15.905 12.4381 15.7879 12.5553L11.0503 17.2929Z"
                fill="black"
              />
              <path
                d="M9.63604 8.05025C9.24551 7.65972 9.24551 7.02656 9.63604 6.63603C10.0266 6.24551 10.6597 6.24551 11.0503 6.63603L15.7172 11.3029C15.8734 11.4591 15.8734 11.7124 15.7172 11.8686L15.2929 12.2929C14.9024 12.6834 14.2692 12.6834 13.8787 12.2929L9.63604 8.05025Z"
                fill="black"
              />
              <path
                d="M5 13C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11L14.7639 11C14.9192 11 15.0723 11.0361 15.2111 11.1056L15.5528 11.2764C15.8269 11.4134 16 11.6936 16 12C16 12.3064 15.8269 12.5866 15.5528 12.7236L15.2111 12.8944C15.0723 12.9639 14.9192 13 14.7639 13L5 13Z"
                fill="black"
              />
            </svg>
          )}
        </button>
      </div>
      <ul
        className={`menu shadow-lg h-screen ${
          isPanelOpen ? "w-56" : "w-24"
        } pl-3 pr-4 `}
      >
        {menuItems.map((item, index) => {
          const isSelected = selectedItem === item.label;

          return (
            <li
              key={index}
              onClick={() => {
                setSelectedItem(item.label);

                const formattedLabel = item.label
                  .toLowerCase()
                  .replace(/\s+/g, "-");

                navigate(`/dashboard/${formattedLabel}`, {
                  replace: true,
                  state: { isPanelOpen },
                });
              }}
              className={`flex ${
                index === 0 ? "pt-16" : ""
              } items-center gap-2 p-2 mb-6 cursor-pointer rounded-lg transition-all duration-200 
          ${
            isSelected
              ? "bg-[rgba(29,39,57,0.10)] text-black"
              : "text-[#7E7E7E]"
          } 
          ${!isPanelOpen ? "justify-center" : "justify-start"}`}
            >
              <span className="icon">{item.icon(isSelected)}</span>
              {isPanelOpen && (
                <span
                  className="text-base font-semibold"
                  style={{ fontFamily: "Lato" }}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SidePanel;
